module.exports = __webpack_public_path__ + "static/media/7.a3813a46.JPG";